import AnalyticsTrackingProvider, { AnalyticsTrackingContext } from './Provider'

export { AnalyticsTrackingProvider, AnalyticsTrackingContext }
export { IAnalyticsTrackingContextProps } from './Provider'

export default AnalyticsTrackingProvider
